/**
 * FBSBancaRIOBAMBA
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Rubros } from './rubros';


export interface PagoProductoME { 
    idProducto?: string;
    secuencialCuentaCliente?: number;
    numeroCuotasPensionesAlimenticiaPersona?: number;
    secuencialResultadoTransaccion?: number;
    valor?: number;
    otp?: string | null;
    jsonComision?: string | null;
    codigoUsuarioBanca?: string | null;
    referencia?: string | null;
    valorTonelaje?: string | null;
    identificacion?: string | null;
    codigoPagarPensionesAlimenticiaEmpresa?: string | null;
    comisionRubro?: boolean;
    esDesdeMovil?: boolean;
    rubros?: Array<Rubros> | null;
    contrasena?: string | null;
    OmitirValidacionContrasena?: boolean;
}

